
export enum DisplayMode {
    Grid = 'GRID',
    Table = 'TABLE'
}